import Base from 'app/collections/base';
import Rate from 'app/models/rate';

export default Base.extend({
  model: Rate,
});



// WEBPACK FOOTER //
// ./app/collections/rates.js